module.exports = __webpack_public_path__ + "img/harpia_logo.880e06fb.png";